module.exports = __webpack_public_path__ + "img/maroon3.0b2517ab.png";